import { VisibilityTypes } from '@src/api';
import { PAGE_SIZE } from '@src/api/common';

export const visibilityTypes = [
  { name: 'Me', value: VisibilityTypes.ForMe },
  { name: 'All', value: VisibilityTypes.ForAll },
  { name: 'Ordering providers', value: VisibilityTypes.ForOrderingProviders },
  { name: 'For one (SR)', value: VisibilityTypes.ForOneSalesRepresentative },
];

export const initialSalesRepFilter = {
  search: '',
  skip: 0,
  take: PAGE_SIZE,
};
